<template>
	<popup title="Are you sure you want to replace your current changes with this version?" @close="closePopup" medium text-only>
		<template v-slot:actions>
			<v-button label="Restore version" slim :loading="loading" @click="restore" />
			<v-button label="Cancel" slim border @click="closePopup" />
		</template>
	</popup>
</template>

<script>
import API from "@/api"
import VSwitch from "@/components/base/v-switch";
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";

export default {
  name: "restore-page-revision-popup",
	components: {VButton, Popup},
	props:['revision'],
    mixins: [API],
    data() {
      return {
        loading: false,
      }
    },
    computed:{
    },
    methods: {
        closePopup() {
          this.$emit('close');
        },
        async restore() {
        	try {
		        this.loading = true
		        let result = await this.api.wsteps.restorePageRevision(this.revision.funnel_id, this.revision.step_id,
				        this.revision.page_id, this.revision.id);
		        if (!result.error) {
			        this.$emit('done');
		        }
	        } catch (e) {
		        this.$warn(e);
	        } finally {
		        this.loading = false
	        }
        },
    },
}
</script>

<style lang="scss" scoped>
.restore-page-revision-popup {
}
</style>
